export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M12 14H36M24 14V38" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 22H32M18 30H30" stroke="#9A7B24" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="24" cy="8" r="2" fill="#8A6D1F" />
    <rect x="8" y="36" width="32" height="2" rx="1" fill="#D4AF37" />
  </svg>
);

export const Logo = () => (
  <div className="flex items-center" data-testid="site-logo">
    <div className="leading-none">
      <span className="block font-display text-xl tracking-[0.18em] text-[#1B3A6B]">TARAH</span>
      <span className="mt-1 block font-label text-[9px] tracking-[0.42em] text-[#9A7B24]">
        CAKE DESIGN STUDIO
      </span>
    </div>
  </div>
);
